var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Drawer', {
    attrs: {
      "class-name": "position_add",
      "title": `${_vm.edit ? $t("ai7f1d4", "修改岗位") : $t("e7xisb4", "添加岗位")}`,
      "width": _vm.isMobile ? '90%' : '800px',
      "mask-closable": false,
      "styles": _vm.styles
    },
    on: {
      "on-close": _vm.close
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('ProForm', {
    ref: "proForm",
    attrs: {
      "label-position": "top",
      "columns": _vm.columns,
      "labelWidth": 165
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }), _c('div', {
    staticClass: "drawer_footer"
  }, [_c('Button', {
    staticClass: "buttons",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v($t("kzjg2", "确定"))])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };